import React from 'react'
import { PlusCircleIcon } from '@heroicons/react/24/outline'

const NewElement = ({ action, isNewCard = false, isNewButton = false, isNewSugegstion = false }) => {
  const getClasses = () => {
    const base =
      'cursor-pointer flex justify-center items-center border-2 border-dashed border-indigo-200 bg-indigo-50/50 rounded-xl hover:border-indigo-400 hover:bg-indigo-50 transition-all duration-200 ease-in-out group'
    if (isNewButton) {
      return `${base} h-14 w-1/3 gap-2`
    }
    if (isNewCard) {
      return `${base} h-80 w-1/3 flex-col gap-3`
    }
    if (isNewSugegstion) {
      return `${base} h-14 w-1/3 gap-2`
    }
    return `${base} h-20 w-1/3 flex-col gap-1.5`
  }

  const getText = () => {
    if (isNewCard) {
      return 'Añadir Tarjeta'
    }
    if (isNewButton) {
      return 'Añadir Botón'
    }
    return 'Nuevo Elemento'
  }

  return (
    <button onClick={() => action()} className={getClasses()}>
      <PlusCircleIcon className="h-6 w-6 text-indigo-300 group-hover:text-indigo-500 transition-colors" />
      <span className="text-sm font-medium text-indigo-400 group-hover:text-indigo-600 transition-colors text-center">
        {getText()}
      </span>
    </button>
  )
}

export default NewElement
